import { useState } from 'react';
import { entranceTabs } from '@/mocks/home';

export default function EntranceSection() {
  const [active, setActive] = useState(entranceTabs[0].key);
  const current = entranceTabs.find((tab) => tab.key === active) ?? entranceTabs[0];

  return (
    <section id="entrance" className="scroll-mt-24 bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-xs md:text-sm text-accent-700 bg-accent-100 px-3 py-1.5 rounded-full">
            <i className="ri-links-line"></i>
            入口类型
          </span>
          <h2 className="mt-4 font-heading text-2xl md:text-4xl text-foreground-950 leading-snug">
            三类入口各自适合什么场景
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
            「入口」并不只有一种。官网首页、备用地址与移动端入口各有侧重，了解它们的差别，
            能让你在需要访问时更快选对通道，也能在判断来源可信度时多几分把握。
          </p>
        </div>

        <div className="mt-8 flex flex-wrap gap-2">
          {entranceTabs.map((tab) => (
            <button
              key={tab.key}
              type="button"
              onClick={() => setActive(tab.key)}
              aria-pressed={active === tab.key}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm transition-colors cursor-pointer whitespace-nowrap border ${
                active === tab.key
                  ? 'bg-primary-500 text-background-50 border-primary-500'
                  : 'bg-background-50 text-foreground-700 border-background-300/70 hover:border-primary-300'
              }`}
            >
              <i className={`${tab.icon} text-base`}></i>
              {tab.label}
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-7 rounded-lg bg-background-50 border border-background-200/70 p-6 md:p-8">
            <div className="flex items-start gap-4">
              <span className="w-12 h-12 shrink-0 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className={`${current.icon} text-2xl`}></i>
              </span>
              <div>
                <h3 className="font-heading text-xl md:text-2xl text-foreground-950">{current.headline}</h3>
                <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-700">{current.desc}</p>
              </div>
            </div>

            <ul className="mt-6 space-y-3">
              {current.points.map((point) => (
                <li key={point} className="flex items-start gap-3 text-sm leading-relaxed text-foreground-700">
                  <i className="ri-checkbox-circle-line mt-0.5 text-accent-600"></i>
                  <span>{point}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-5 flex flex-col gap-6">
            <div className="rounded-lg bg-secondary-100 border border-secondary-200/70 p-6">
              <div className="flex items-center gap-2 text-secondary-900">
                <i className="ri-lightbulb-line text-lg"></i>
                <h3 className="font-heading text-base">使用提醒</h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-secondary-900/85">{current.note}</p>
            </div>

            <div className="rounded-lg bg-background-50 border border-background-200/70 p-6">
              <h3 className="font-heading text-base text-foreground-950">快速对照</h3>
              <dl className="mt-4 space-y-3 text-sm">
                <div className="flex items-center justify-between gap-3">
                  <dt className="text-foreground-600">可信度最高</dt>
                  <dd className="text-foreground-950 font-medium">官网入口</dd>
                </div>
                <div className="flex items-center justify-between gap-3">
                  <dt className="text-foreground-600">主入口不可用时</dt>
                  <dd className="text-foreground-950 font-medium">备用地址</dd>
                </div>
                <div className="flex items-center justify-between gap-3">
                  <dt className="text-foreground-600">手机与平板访问</dt>
                  <dd className="text-foreground-950 font-medium">移动端入口</dd>
                </div>
              </dl>
              <p className="mt-4 text-xs leading-relaxed text-foreground-600">
                无论使用哪一类入口，都应先确认来源，再决定是否继续。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}